import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface SidebarProps { activePage: string; onNavigate: (page: string) => void; }

const NAV = [
  { id: 'dashboard', icon: '📊', label: 'Dashboard', section: 'Principal' },
  { id: 'studio', icon: '🎬', label: 'Studio', section: null },
  { id: 'generator', icon: '✨', label: 'Générateur', section: null },
  { id: 'hooks', icon: '🎣', label: 'Hooks viraux', section: 'Contenu' },
  { id: 'scripts', icon: '🎬', label: 'Scripts vidéo', section: null },
  { id: 'calendar', icon: '📅', label: 'Calendrier 30j', section: null },
  { id: 'viral', icon: '🔥', label: 'Viral Engine', section: null },
  { id: 'agent', icon: '🤖', label: 'Agent Réalisateur', section: 'Création' },
  { id: 'variantes', icon: '✨', label: '10 Variantes', section: null },
  { id: 'coach', icon: '🧠', label: 'IA Coach', section: null },
  { id: 'analytics', icon: '📊', label: 'Analytics V3+V4', section: null },
  { id: 'youtube', icon: '🔴', label: 'YouTube Shorts', section: 'Réseaux' },
  { id: 'tiktok', icon: '🎵', label: 'TikTok', section: null },
  { id: 'icp', icon: '🎯', label: 'ICP Engine', section: null },
  { id: 'plans', icon: '💎', label: 'Abonnements', section: 'Compte' },
];

const Sidebar: React.FC<SidebarProps> = ({ activePage, onNavigate }) => {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const nav = (p: string) => { onNavigate(p); setMenuOpen(false); };
  const mobileNav = [
    { id: 'dashboard', icon: '📊', label: 'Home' },
    { id: 'studio', icon: '🎬', label: 'Studio' },
    { id: 'scripts', icon: '🎬', label: 'Scripts' },
    { id: 'viral', icon: '🔥', label: 'Viral' },
    { id: 'menu', icon: '☰', label: 'Menu' },
  ];

  const navBtn = (item: typeof NAV[0]) => (
    <button key={item.id} onClick={() => nav(item.id)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, cursor: 'pointer', color: activePage === item.id ? '#8B6FFF' : '#C8C8E8', fontSize: 13, fontWeight: activePage === item.id ? 700 : 500, marginBottom: 2, border: 'none', width: '100%', textAlign: 'left', background: activePage === item.id ? 'rgba(108,71,255,0.2)' : 'transparent' }}>
      <span style={{ fontSize: 15 }}>{item.icon}</span>{item.label}
    </button>
  );

  return (
    <>
      <style>{`
        @media (max-width: 768px) { .desktop-sidebar { display: none !important; } .mobile-topbar { display: flex !important; } .mobile-bottom-nav { display: flex !important; } }
      `}</style>

      {/* Desktop Sidebar */}
      <nav className="desktop-sidebar" style={{ position: 'fixed', left: 0, top: 0, bottom: 0, width: 220, background: '#12121F', borderRight: '1px solid #1E1E35', display: 'flex', flexDirection: 'column', padding: '20px 12px', overflowY: 'auto', zIndex: 100 }}>
        <div style={{ padding: '0 8px 20px', borderBottom: '1px solid #1E1E35', marginBottom: 14 }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#F8F7FF' }}>Contenu<span style={{ color: '#6C47FF' }}>IA</span> <span style={{ color: '#00F5A0', fontSize: 10 }}>●</span></div>
          <div style={{ fontSize: 10, color: '#C8C8E8', marginTop: 2 }}>Créer. Publier. Dominer.</div>
        </div>
        {NAV.map(item => (
          <React.Fragment key={item.id}>
            {item.section && <div style={{ fontSize: 9, fontWeight: 800, color: '#6C6C8A', textTransform: 'uppercase', letterSpacing: 1.5, padding: '12px 8px 4px' }}>{item.section}</div>}
            {navBtn(item)}
          </React.Fragment>
        ))}
        <div style={{ marginTop: 'auto', paddingTop: 16 }}>
          {user?.isAdmin && <div style={{ padding: '7px 12px', background: 'rgba(0,245,160,0.1)', borderRadius: 10, border: '1px solid rgba(0,245,160,0.3)', marginBottom: 10, fontSize: 11, color: '#00F5A0', fontWeight: 600, textAlign: 'center' }}>⚡ Admin — Illimité</div>}
          <button onClick={logout} style={{ width: '100%', padding: '9px', background: 'transparent', border: '1px solid #3A3A5C', borderRadius: 9, color: '#C8C8E8', fontSize: 12, cursor: 'pointer' }}>🚪 Déconnexion</button>
        </div>
      </nav>

      {/* Mobile Top Bar */}
      <div className="mobile-topbar" style={{ display: 'none', position: 'fixed', top: 0, left: 0, right: 0, height: 56, background: '#12121F', borderBottom: '1px solid #1E1E35', zIndex: 200, alignItems: 'center', justifyContent: 'space-between', padding: '0 16px' }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#F8F7FF' }}>Contenu<span style={{ color: '#6C47FF' }}>IA</span></div>
        {user?.isAdmin && <span style={{ fontSize: 10, color: '#00F5A0', fontWeight: 700 }}>⚡ Admin</span>}
      </div>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 300 }} onClick={() => setMenuOpen(false)}>
          <div style={{ width: 260, background: '#12121F', height: '100%', padding: '20px 12px', overflowY: 'auto', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: '#F8F7FF' }}>Contenu<span style={{ color: '#6C47FF' }}>IA</span></div>
              <button onClick={() => setMenuOpen(false)} style={{ background: 'none', border: 'none', color: '#C8C8E8', fontSize: 24, cursor: 'pointer' }}>✕</button>
            </div>
            {NAV.map(item => (
              <React.Fragment key={item.id}>
                {item.section && <div style={{ fontSize: 9, fontWeight: 800, color: '#6C6C8A', textTransform: 'uppercase', letterSpacing: 1.5, padding: '12px 8px 4px' }}>{item.section}</div>}
                {navBtn(item)}
              </React.Fragment>
            ))}
            <button onClick={logout} style={{ marginTop: 'auto', width: '100%', padding: '12px', background: 'transparent', border: '1px solid #3A3A5C', borderRadius: 10, color: '#C8C8E8', fontSize: 14, cursor: 'pointer' }}>🚪 Déconnexion</button>
          </div>
        </div>
      )}

      {/* Mobile Bottom Nav */}
      <div className="mobile-bottom-nav" style={{ display: 'none', position: 'fixed', bottom: 0, left: 0, right: 0, height: 64, background: '#12121F', borderTop: '1px solid #1E1E35', zIndex: 200, alignItems: 'center', justifyContent: 'space-around' }}>
        {mobileNav.map(item => (
          <button key={item.id} onClick={() => item.id === 'menu' ? setMenuOpen(true) : nav(item.id)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, background: 'none', border: 'none', cursor: 'pointer', color: activePage === item.id ? '#8B6FFF' : '#6C6C8A', padding: '8px 12px', borderRadius: 10, flex: 1 }}>
            <span style={{ fontSize: 22 }}>{item.icon}</span>
            <span style={{ fontSize: 9, fontWeight: 600 }}>{item.label}</span>
          </button>
        ))}
      </div>
    </>
  );
};

export default Sidebar;
